<p-dialog
  [header]="modalTitle"
  [(visible)]="displayDialog"
  showeffect="fade"
  [modal]="true"
  [styleClass]="'add-dialog'"
  [blockScroll]="true"
  ><div class="spinner" *ngIf="isLoadingFormFields">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div class="modal-content" *ngIf="!isLoadingFormFields">
    <form (ngSubmit)="onSubmit()" [formGroup]="form" *ngIf="form && formFields.length >= 3">
      <div class="grid">
        <div class="col-6">
          <form-field [formField]="formFields[0]" [form]="form"></form-field>
        </div>
        <div class="col-6">
          <form-field [formField]="formFields[1]" [form]="form"></form-field>
        </div>
        <div class="col-10">
          <form-field [formField]="formFields[2]" [form]="form"></form-field>
        </div>
      </div>
    </form>
  </div>
  <p-toast> </p-toast
  ><ng-template pTemplate="footer" [style]="{'overflow': 'hidden','max-height': 'max-content','height': 'fit-content'}"
    ><div class="p-dialog-buttonpane ui-helper-clearfix">
      <button class="crm-button" type="button" (click)="onSubmit()" [disabled]="isLoading || isLoadingFormFields" label="Submit">Submit</button
      ><button class="crm-button" type="button" (click)="onCancel()" label="Cancel">Cancel</button>
    </div></ng-template
  ></p-dialog
>
